import { useConfig } from '../../config';
import { useTranslation } from '../../i18n/i18n';
import { formatZipByLocale } from './utils';

// Can represent both an InvoiceAddress and a DeliveryAddress
export type RelaxedAddress = {
	dob?: string;
	company: string;
	firstname?: string;
	lastname?: string;
	phone?: string;
	email?: string;
	street: string;
	careOf?: string;
	doorCode?: string;
	ref?: string;
	ref1?: string;
	ref2?: string;
	zip: string;
	city: string;
};

// Can display both a InvoiceAddress and a DeliveryAddress
type AddressSummaryProps = { address: RelaxedAddress };
export function AddressSummary({ address }: AddressSummaryProps): JSX.Element {
	const { locale } = useConfig();
	const t = useTranslation().form;
	const { dob, company, firstname, lastname, phone, email, ref, ref1, ref2, street, careOf, doorCode, zip, city } =
		address;
	if (
		!dob &&
		!company &&
		!firstname &&
		!lastname &&
		!phone &&
		!email &&
		!ref &&
		!ref1 &&
		!ref2 &&
		!street &&
		!careOf &&
		!doorCode &&
		!zip &&
		!city
	)
		return <></>;
	return (
		<dl>
			{company} {careOf ? `c/o ${careOf}` : ''}
			<br />
			{firstname || lastname ? (
				<>
					{firstname} {lastname}
				</>
			) : null}
			{email ? (
				<>
					<dd>{email}</dd>
				</>
			) : null}
			{dob ? (
				<>
					<dd>{dob}</dd>
				</>
			) : null}
			{ref ? (
				<>
					<dd>{ref}</dd>
				</>
			) : null}
			{ref1 ? (
				<>
					<dd>{ref1}</dd>
				</>
			) : null}
			{ref2 ? (
				<>
					<dd>{ref2}</dd>
				</>
			) : null}
			<dd>{street}</dd>
			{doorCode ? (
				<>
					<dd>
						{t.doorCode}: {doorCode}
					</dd>
				</>
			) : null}
			<dd>
				{formatZipByLocale(zip, locale)} {city}
			</dd>
			{phone ? (
				<>
					<br />
					<dd>{phone}</dd>
				</>
			) : null}
		</dl>
	);
}
